import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Alert, Button, Card, Form, Input, message } from "antd";

import classes from "./SetPassword.module.scss";
import { setPasswordAPI, resetPasswordAPI } from "../../API/endpoints/auth";
import { passwordValidator } from "../../utils/validation";
import ReCaptcha from "./ReCaptcha";

export default function SetPasswordCard({ title, reset = false }) {
  const [error, setError] = useState();
  const [loading, setLoading] = useState();
  const [captchaValue, setCaptchaValue] = useState(null);

  const [messageApi, contextHolder] = message.useMessage();
  const [searchParams] = useSearchParams();
  const confirmToken = searchParams.get("token");

  const [form] = Form.useForm();

  const confirmPasswordValidator = (_, value) => {
    if (!value) {
      return Promise.reject(new Error("Please confirm your password"));
    }
    if (value !== form.getFieldValue("password")) {
      return Promise.reject(new Error("Passwords do not match"));
    }
    return Promise.resolve();
  };

  const handleSubmit = async (values) => {
    try {
      setError(false);
      setLoading(true);
      reset
        ? await resetPasswordAPI(values, confirmToken, captchaValue)
        : await setPasswordAPI(values, confirmToken);
      messageApi.open({
        type: "success",
        style: {
          marginTop: 100,
        },
        content:
          "Password has been changed. Now you can go to login page and login with your new password",
      });
    } catch (error) {
      setError(
        error.response?.data?.errorDetails
          ? error.response?.data?.errorDetails[0]
          : error.response?.data?.message || "Something went wrong"
      );
      setCaptchaValue(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card title={title} className={classes.card}>
      {error && <Alert message={error} type="error" />}
      {contextHolder}
      <Form
        form={form}
        name="basic"
        onFinish={handleSubmit}
        autoComplete="off"
        layout="vertical"
        size="large"
      >
        <Form.Item
          label="Password"
          name="password"
          rules={[{ validator: passwordValidator, max: 128 }]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          label="Confirm password"
          name="confirmPassword"
          rules={[{ validator: confirmPasswordValidator, max: 128 }]}
        >
          <Input.Password />
        </Form.Item>

        {reset && <ReCaptcha value={captchaValue} onChange={setCaptchaValue} />}

        <Form.Item className={classes.submitButton}>
          <Button type="primary" htmlType="submit" block disabled={loading}>
            {loading ? "Loading..." : "Confirm"}
          </Button>
        </Form.Item>
      </Form>
      <Link to={"/auth/login"} className={classes.clickableSpan}>
        Back to Login
      </Link>
    </Card>
  );
}
